import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { DataStateChangeEvent, PageChangeEvent } from '@progress/kendo-angular-grid';
import { NotifierService } from 'angular-notifier';
import { CourierPackageService } from '../service/courier-package.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DocumentExtractionModel } from '../Model/DocumentExraction.Model';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import { process } from '@progress/kendo-data-query';


@Component({
  selector: 'app-courierpackage-success',
  templateUrl: './courierpackage-success.component.html',
  styleUrls: ['./courierpackage-success.component.scss']
})
export class CourierpackageSuccessComponent implements OnInit {
  @ViewChild('openDocumentInfoModalButton', { static: false }) openEditModalButton: ElementRef;
  public deleteId = 0;
  public searchTerm = '';
  public showConfirmation = false;
  public userList: any[] = [];
  public isPageReady = true;
  public pageSize = 10;
  public skip = 0;
  public showModel=false;
  public selecteddocumentId=0;
  public gridViewSearch: any;
  public gridView: any;
  public documentInfo= new DocumentExtractionModel();
  public incomingDate: Date = new Date();
  public inputDate;
  public gridState: DataStateChangeEvent = {
    skip: this.skip,
    take: this.pageSize
  };
  private readonly notifier: NotifierService;

  constructor(private packageService: CourierPackageService,private router: Router,private route:ActivatedRoute,public datepipe: DatePipe) {
    this.allData = this.allData.bind(this);
   }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      var updatedDate = params['incomingDate'];
      if(updatedDate){
        this.incomingDate = new Date(updatedDate);
        this.inputDate = updatedDate;
      }
  });
 
    this.dataStateChange(this.gridState, this.inputDate);
  }


  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.userList
    };

    return result;
  }




  viewDocumentInfo(documentId:number , edit: boolean) {
    this.selecteddocumentId=documentId;
    this.packageService.getdocumentInfoById(documentId).subscribe((result: DocumentExtractionModel) => {
      this.documentInfo = result;
      this.documentInfo.pickupDateString=this.datepipe.transform(this.documentInfo.pickupDate, 'dd-MMM-yyyy');
      this.showModel=true;
      this.openEditModalButton.nativeElement.click();
    }, error => {console.error(error); console.log('error'); });
  }


  LoadDocumentInfo(documentId) {
   
 }

  public pageChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    this.loadItems();
}

private loadItems(): void {
  this.gridView = process(this.userList, this.gridState);
}

  dataStateChange(state: DataStateChangeEvent,incomingDate:any) {
    this.isPageReady = false;
    this.gridState = state;
    // Gets data from api
    this.packageService.getDocumentSuccessInfo(incomingDate).subscribe((data: any) => {
      // Binds the data to grid
      if(data){
        var items="";
      data.forEach(item=>{
        item.pickupDate=this.datepipe.transform(item.pickupDate, 'dd-MMM-yyyy');
        item.incomingDate=this.datepipe.transform(item.incomingDate, 'dd-MMM-yyyy');
      });
      this.gridView = {
        data: data.slice(this.skip, this.skip + this.pageSize),
        total: data.length
    };
    this.gridViewSearch = data.map(x => Object.assign({}, x));
      this.userList = data;
      this.isPageReady = true;
  }
    },
    (error) => {
      this.notifier.notify('error', 'Error occured while getting data from server');
      this.isPageReady = true;
    }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    let filterData = this.gridViewSearch.filter(r => r.incomingDate.toLowerCase().includes(filterValue)
    || r.office.toLowerCase().includes(filterValue)
    || r.fileName.toLowerCase().includes(filterValue));
    this.gridView.data = filterData;
    this.gridView.total=filterData.length;
    // console.log(this.gridView);
  }

}
